import { NewsData, NewsValidationState } from "../types";
import { createUseValidator } from "../../../../core/util/hooks";

export const newsValidationState: NewsValidationState = {
  title: true,
  newsTime: true,
  filesr: true,   // ✅ dodajemo obavezno izbor fajla
};

// export const useNewsValidator = createUseValidator<
// NewsData,
//   NewsValidationState
// >(newsValidationState);

export const useNewsValidator = createUseValidator<NewsData, NewsValidationState>(
  newsValidationState,
  (news) => ({
    title: !!news.title,             // naslov mora postojati
    newsTime: !!news.newsTime,       // datum mora postojati
    filesr: news.newsId ? true : !!news.filesr, // ✅ PDF obavezan kod nove vesti
  })
);
